export default function (ctx, inject) {
    // Options
    const nuxtConfigOptions = {"searchCategories":["posts","postCategories","pages"]}

    inject('moduleOptions', nuxtConfigOptions)
}
